module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wizardWrapper"
  }, [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.loading) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')) + " "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])]) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v(_vm._s(_vm.$t('static.module.subscribe.title')))]), _vm._v(" "), (!_vm.settings.hasFikenToken) ? _c('p', [_vm._v(_vm._s(_vm.$t('static.module.fiken.intro')))]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.settings.hasFikenToken) ? _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "static.module.fiken",
      "hasLabel": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div')], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.close')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.authorize
    }
  }, [_vm._v(_vm._s(_vm.$t('button.subscribe').toUpperCase()))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f48a3aa","hasScoped":false}!./src/app/components/accountingSetupFiken/accountingSetupFiken.html
// module id = 2936
// module chunks = 1